var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-histogram"},[_c('ve-histogram',{attrs:{"data":_vm.chartData,"settings":_vm.chartSettings,"extend":_vm.extend,"legend-visible":false,"tooltip-visible":false,"height":"80px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }